import { MailOutlined } from '@ant-design/icons';
import { USER_STATUSES } from '../../constants/constants';

export const getSortedAdmins = (state, styles) =>
  state?.healthOrganizations?.activeChildHOAdmins?.map((u) => ({
      ...u,
      title: (
        <div className={styles.styledOption}>
          {u.status !== USER_STATUSES.ACTIVE && <MailOutlined className={styles.mailIcon} />}
          <span>
            {u.firstName} {u.lastName} {u.email}
          </span>
        </div>
      ),
      value: u.id,
      disabled: u.status !== USER_STATUSES.ACTIVE,
    }))
    .sort((a, b) => a.disabled - b.disabled);
